import { usePlayer } from "../context/PlayerContext";
import { mediaUrl } from "../lib/api";
import { fmtTime } from "../lib/utils2";
import { Play, Pause, SkipForward, SkipBack, Lock, X } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const speeds = [1, 1.25, 1.5, 2];

export const AudioPlayer = () => {
  const { current, playing, progress, duration, speed, toggle, seek, skip, changeSpeed } = usePlayer();
  const [hidden, setHidden] = useState(false);
  const nav = useNavigate();
  if (!current || hidden) return null;

  const cycleSpeed = () => {
    const i = speeds.indexOf(speed);
    changeSpeed(speeds[(i + 1) % speeds.length]);
  };

  return (
    <div data-testid="audio-player" className="fixed bottom-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-t border-slate-200/60 shadow-[0_-8px_30px_rgb(0,0,0,0.1)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3">
        <div className="flex items-center gap-4">
          <img src={mediaUrl(current.cover_url)} alt="" className="w-12 h-12 rounded-lg object-cover hidden sm:block" />
          <div className="min-w-0 flex-1 sm:flex-none sm:w-48">
            <p className="text-sm font-semibold text-navy truncate">{current.title}</p>
            <p className="text-xs text-slate-400 truncate flex items-center gap-1">
              {current.locked && <Lock className="w-3 h-3 text-gold" />}
              {current.locked ? "Anteprima" : current.category}
            </p>
          </div>

          <div className="flex items-center gap-2">
            <button onClick={() => skip(-15)} data-testid="player-back-15" className="p-2 text-slate-500 hover:text-navy transition-colors"><SkipBack className="w-5 h-5" /></button>
            <button onClick={toggle} data-testid="player-toggle" className="w-11 h-11 rounded-full bg-navy text-white flex items-center justify-center hover:bg-petrol transition-colors shadow-md">
              {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
            </button>
            <button onClick={() => skip(15)} data-testid="player-forward-15" className="p-2 text-slate-500 hover:text-navy transition-colors"><SkipForward className="w-5 h-5" /></button>
          </div>

          <div className="flex-1 items-center gap-3 hidden md:flex">
            <span className="text-xs text-slate-400 tabular-nums w-10 text-right">{fmtTime(progress)}</span>
            <input type="range" min={0} max={duration || 0} value={progress} onChange={(e) => seek(parseFloat(e.target.value))}
              data-testid="player-seek" className="audio-range flex-1 bg-slate-200" style={{ background: `linear-gradient(to right, #0B1E36 ${(progress / (duration || 1)) * 100}%, #e2e8f0 0%)` }} />
            <span className="text-xs text-slate-400 tabular-nums w-10">{fmtTime(duration)}</span>
          </div>

          <button onClick={cycleSpeed} data-testid="player-speed" className="text-xs font-semibold text-navy bg-slate-100 rounded-full px-3 py-1.5 hover:bg-slate-200 transition-colors w-14">{speed}x</button>
          {current.locked && (
            <button onClick={() => nav("/abbonamenti")} data-testid="player-unlock" className="hidden sm:flex bg-gold text-navy rounded-full px-4 py-1.5 text-xs font-semibold hover:bg-navy hover:text-white transition-colors">Sblocca</button>
          )}
          <button onClick={() => setHidden(true)} className="p-1.5 text-slate-400 hover:text-navy"><X className="w-4 h-4" /></button>
        </div>
      </div>
    </div>
  );
};
